<template>
    <div class="work">
        <div class="page-intro">
            <div><h1>我的作品</h1><p>数字插花、现代花艺 / 园林景观 3D 与花艺环境 2D 作品统一管理</p></div>
            <el-dropdown trigger="click">
                <el-button type="success"><i class="el-icon-plus"></i> 新建作品</el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item><a class="new-work-editor-link" :href="buildEditorUrl('TRADITIONAL_FLOWER')" target="_blank" rel="noopener noreferrer">数字插花 · 3D</a></el-dropdown-item>
                    <el-dropdown-item><a class="new-work-editor-link" :href="buildEditorUrl('LANDSCAPE')" target="_blank" rel="noopener noreferrer">现代花艺 / 园林景观 · 3D</a></el-dropdown-item>
                    <el-dropdown-item><a class="new-work-editor-link" :href="buildEditorUrl('FLORAL_ENVIRONMENT')" target="_blank" rel="noopener noreferrer">花艺环境 · 2D</a></el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div class="work-toolbar">
            <el-radio-group v-model="activeName" fill="#21965b" @change="changeTab">
                <el-radio-button label="TRADITIONAL_FLOWER">数字插花</el-radio-button>
                <el-radio-button label="LANDSCAPE">现代花艺 / 园林景观 · 3D</el-radio-button>
                <el-radio-button label="FLORAL_ENVIRONMENT">花艺环境 · 2D</el-radio-button>
            </el-radio-group>
            <div class="toolbar-right">
                <el-input v-model.trim="workKeyword" prefix-icon="el-icon-search" placeholder="搜索当前页作品名称" clearable></el-input>
                <el-button plain @click="activeName = 'collect'">常用素材</el-button>
            </div>
        </div>
        <div v-if="activeName !== 'collect'" class="work-summary">共 {{ work.total }} 个作品 · 最近编辑优先</div>
        <div v-if="activeName !== 'collect'" v-loading="work.loading">
            <div v-if="!work.loading && !visibleWorks.length" class="no_data">
                <i class="iconfont icon-queshengye_zanwushuju"></i>
                <div>{{ workKeyword ? '当前页没有匹配的作品' : '暂无数据' }}</div>
            </div>
            <div v-if="!work.loading && visibleWorks.length" class="data_list">
                <div
                    v-for="(item, index) in visibleWorks"
                    :key="item.id || index"
                    class="work-card"
                    :class="isTraditionalWork(item) ? 'work-card--traditional' : 'work-card--creative'"
                >
                    <div
                        class="work-cover"
                        :style="item.coverImage | imgFormat(true)"
                        @click="toDetail(item)"
                    >
                        <template v-if="isTraditionalWork(item)">
                            <div
                            class="ls_flexalign_center opt_part"
                            @click.stop=""
                            >
                                <div class="ls_flex_center" @click="share(item)">
                                    <i class="iconfont icon-fenxiang" />
                                    分享
                                </div>
                                <div class="ls_flex_center" @click="getInfo(item)">
                                    <i class="iconfont icon-bianji" />
                                    信息
                                </div>
                                <div
                                    class="ls_flex_center"
                                    @click="viewMaterials(item)"
                                >
                                    <i class="iconfont icon-tiezi" />
                                    用料
                                </div>
                                <div class="ls_flex_center" @click="del(item)">
                                    <i class="iconfont icon-shanchu" />
                                    删除
                                </div>
                            </div>
                            <div
                                class="ls_flexalign_center opt_part2"
                                @click.stop=""
                            >
                                <div class="ls_flex_center opt_part2_1" @click="design(item)">
                                    做效果图
                                </div>
                                <div class="ls_flex_center" @click="download(item.effectImageHrss)">
                                    下载效果图
                                </div>
                                <div class="ls_flex_center" @click="download(item.coverImage)">
                                    <i class="iconfont icon-xiazai" />
                                    下载主图
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <span class="work-type-tag">{{ creativeWorkLabel(item) }}</span>
                            <el-dropdown
                                class="creative-more"
                                trigger="click"
                                placement="bottom-end"
                                @click.native.stop
                                @command="handleCreativeCommand($event, item)"
                            >
                                <button class="creative-more-button" type="button" aria-label="更多操作">
                                    <i class="el-icon-more"></i>
                                </button>
                                <el-dropdown-menu slot="dropdown" class="creative-action-menu">
                                    <el-dropdown-item command="rename">重命名</el-dropdown-item>
                                    <el-dropdown-item command="delete">删除</el-dropdown-item>
                                    <el-dropdown-item divided command="export-4k">4K 高清图导出</el-dropdown-item>
                                    <el-dropdown-item command="export-pdf">PDF 导出</el-dropdown-item>
                                    <el-dropdown-item command="export-excel">导出素材清单</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <div class="creative-open-tip"><i class="el-icon-edit-outline"></i> 点击继续编辑</div>
                        </template>
                    </div>
                    <div class="work-meta">
                        <div class="work-name">{{ item.name }}</div>
                        <div v-if="!isTraditionalWork(item)" class="work-time">{{ workTime(item) }}</div>
                    </div>
                </div>
            </div>
            <div style="text-align: center; margin-top: 10px">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="work.total"
                    :current-page.sync="work.params.pageIndex"
                    :page-size="work.params.pageSize"
                    @current-change="getWorkList"
                ></el-pagination>
            </div>
        </div>
        <div v-if="activeName === 'collect'">
            <div
                v-if="!collect.loading && !collect.list.length"
                class="no_data"
            >
                <i class="iconfont icon-queshengye_zanwushuju"></i>
                <div>暂无数据</div>
            </div>
            <div
                v-if="!collect.loading && collect.list.length"
                class="data_list collect_list"
            >
                <div v-for="(item, index) in collect.list" :key="index">
                    <div :style="item.coverImage | imgFormat(true)">
                        <div
                            class="ls_flexalign_center opt_part"
                            @click.stop=""
                        >
                            <div class="ls_flex_center" @click="cancel(item)">
                                <i class="iconfont icon-shoucang1" />
                                取消收藏
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>{{ item.name }}</div>
                        <el-tag size="small" class="scene_tag">
                            {{ item.sceneType | sceneTypeName }}
                        </el-tag>
                    </div>
                </div>
            </div>
            <div style="text-align: center; margin-top: 10px">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="collect.total"
                    :current-page.sync="collect.params.pageIndex"
                    :page-size="collect.params.pageSize"
                    @current-change="getCollectList"
                ></el-pagination>
            </div>
        </div>
        <el-dialog title="修改作品信息" :visible.sync="infoShow" width="600px">
            <el-form label-width="80px" v-if="infoShow">
                <el-form-item label="作品名称">
                    <el-input v-model="info.name"></el-input>
                </el-form-item>

                <el-form-item label="">
                    <el-button type="primary" @click="confirm">确定</el-button>
                    <el-button @click="infoShow = false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="用料" :visible.sync="materialsShow" width="400px">
            <div v-for="(item, index) in materials" :key="index">
                <span class="lh26 fz14 cf21 mr10">⬤</span>
                <span class="lh26 fz14">
                    {{ item.materialName }} x{{ item.count }}
                </span>
            </div>
        </el-dialog>

        <el-dialog title="分享" :visible.sync="shareShow" width="400px">
            <img class="share_pop" :src="imgUrl" />
            <div style="text-align: center; margin-top: 25px; font-size: 18px">
                微信扫一扫，三维作品发送手机
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import { exportFourKImage, exportImagePdf, exportMaterialsExcel } from '@/plugins/workExport';
export default {
    data() {
        return {
            activeName: 'TRADITIONAL_FLOWER',
            workRequestId: 0,
            work: {
                total: 0,
                params: {
                    sceneType: 'TRADITIONAL_FLOWER',
                    pageIndex: 1,
                    pageSize: 8,
                },
                loading: true,
                list: [],
            },
            collect: {
                total: 0,
                params: {
                    type: 'FLOWER',
                    pageIndex: 1,
                    pageSize: 8,
                },
                loading: true,
                list: [],
                number: {
                    flower: 0,
                    cover: 0,
                },
            },
            draft: {
                total: 0,
                params: {
                    pageIndex: 1,
                    pageSize: 8,
                },
                loading: true,
                list: [],
            },
            infoShow: false,
            shareShow: false,
            materialsShow: false,
            workKeyword: '',

            imgUrl: '',
            info: '',
            materials: [],
        };
    },
    mounted() {
        this.getWorkList();
        this.getCollectList();
    },
    computed: {
        visibleWorks() {
            const keyword = this.workKeyword.toLowerCase();
            return keyword ? this.work.list.filter(item => (item.name || '').toLowerCase().includes(keyword)) : this.work.list;
        },
        practiceLabel() {
            const labels = {
                LANDSCAPE: '进入景观练习',
                FLORAL_ENVIRONMENT: '进入环境练习',
            };
            return labels[this.activeName] || '进入插花练习';
        },
    },
    methods: {
        workSceneType(item) {
            return item.sceneType || this.work.params.sceneType;
        },
        isTraditionalWork(item) {
            return this.workSceneType(item) === 'TRADITIONAL_FLOWER';
        },
        creativeWorkLabel(item) {
            return this.workSceneType(item) === 'FLORAL_ENVIRONMENT'
                ? '花艺环境 · 2D'
                : '现代花艺 / 园林景观 · 3D';
        },
        workTime(item) {
            const time = item.updateTime || item.createTime || item.createDate || '';
            return time ? `编辑于 ${String(time).replace('T', ' ').slice(0, 16)}` : '最近编辑';
        },
        async handleCreativeCommand(command, item) {
            if (command === 'rename') {
                this.getInfo(item);
                return;
            }
            if (command === 'delete') {
                this.del(item);
                return;
            }
            if (!item.coverImage && command !== 'export-excel') {
                this.$message.warning('该作品暂无可导出的图片');
                return;
            }
            try {
                if (command === 'export-4k') {
                    await exportFourKImage(item.coverImage, item.name);
                    this.$message.success('4K 高清图导出成功');
                } else if (command === 'export-pdf') {
                    exportImagePdf(item.coverImage, item.name);
                } else if (command === 'export-excel') {
                    const count = exportMaterialsExcel(item);
                    this.$message.success(count ? '素材清单导出成功' : '已导出空素材清单');
                }
            } catch (error) {
                this.$message.error(error.message || '导出失败');
            }
        },
        changeTab(value) {
            if (value === 'collect') return;
            this.workKeyword = '';
            this.work.params.sceneType = value;
            this.work.params.pageIndex = 1;
            this.work.list = [];
            this.work.total = 0;
            this.getWorkList();
        },
        async getWorkList() {
            const requestId = ++this.workRequestId;
            this.work.loading = true;
            try {
                const res = await this.$ajax.post('/product/queryList', { ...this.work.params });
                if (requestId !== this.workRequestId) return;
                this.work.total = res.total;
                this.work.list = res.list;
            } finally {
                if (requestId === this.workRequestId) {
                    this.work.loading = false;
                }
            }
        },
        buildEditorUrl(sceneType, params = {}) {
            const editorMap = {
                TRADITIONAL_FLOWER: { address: this.$editAddr },
                LANDSCAPE: { address: this.$gardenEditAddr },
                FLORAL_ENVIRONMENT: { address: this.$gardenEditAddr, type: '2d' },
            };
            const editor = editorMap[sceneType];
            if (!editor) return '';
            const authToken = localStorage.getItem('authToken') || localStorage.getItem('access_token') || '';
            const query = new URLSearchParams(params);
            if (authToken) query.set('authToken', authToken);
            if (editor.type) query.set('type', editor.type);
            return query.toString() ? `${editor.address}?${query.toString()}` : editor.address;
        },
        openEditor(sceneType, params = {}) {
            const url = this.buildEditorUrl(sceneType, params);
            if (!url) {
                this.$message.warning(
                    localStorage.getItem('authToken')
                        ? '暂未找到对应的编辑器入口'
                        : '登录状态已失效，请重新登录'
                );
                return;
            }
            const editorWindow = window.open(url, '_blank');
            if (!editorWindow) {
                this.$message.warning('编辑器窗口被浏览器拦截，请允许本站打开新窗口');
                return;
            }
            editorWindow.opener = null;
        },
        toEdit() {
            this.openEditor(this.activeName);
        },
        //删除
        del(obj) {
            this.$confirm('删除后不可恢复，确定是否删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnClickModal: false,
            }).then(() => {
                this.$ajax
                    .get('/product/delete', {
                        params: {
                            id: obj.id,
                        },
                    })
                    .then(() => {
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                        });
                        this.getWorkList();
                    });
            });
        },
        design(item) {
            const sceneType = item.sceneType || this.work.params.sceneType;
            if (sceneType === 'FLORAL_ENVIRONMENT') {
                this.toDetail(item);
                return;
            }
            this.openEditor(sceneType, { type: 'design', productId: item.id });
        },
        download(url) {
            if (!url) {
                this.$message({
                    message: '图片不存在',
                    type: 'warning',
                });
                return;
            }
            // 创建一个临时的 a 标签用于下载
            const link = document.createElement('a');
            
            // 设置图片地址
            link.href = "https://lvshuhualv.oss-cn-hangzhou.aliyuncs.com/" + url;
            
            // 从URL中提取文件名，或者设置默认文件名
            const urlParts = url.split('/');
            const fileName = urlParts[urlParts.length - 1] || `image_${Date.now()}.jpg`;
            
            // 设置下载属性和文件名
            link.download = fileName;
            
            // 确保链接在视口外，避免闪烁
            link.style.display = 'none';
            
            // 添加到文档中
            document.body.appendChild(link);
            
            // 触发点击事件开始下载
            link.click();
            
            // 下载完成后从文档中移除
            document.body.removeChild(link);
        },
        cancel(item) {
            this.$confirm('确定取消收藏?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnClickModal: false,
            }).then(() => {
                this.$ajax
                    .get('/material/deleteLikeMaterial', {
                        params: {
                            materialId: item.id,
                        },
                    })
                    .then(res => {
                        this.$message({
                            message: '取消成功',
                            type: 'success',
                        });
                        this.getCollectList();
                    });
            });
        },
        //去详情
        toDetail(item) {
            const sceneType = item.sceneType || this.work.params.sceneType;
            this.openEditor(sceneType, { mode: 'edit', productId: item.id });
        },
        //获取收藏数据
        getCollectList() {
            this.$ajax
                .post('/material/queryLikeMaterialList', this.collect.params)
                .then(res => {
                    console.log(res);
                    this.collect.loading = false;
                    this.collect.total = res.total;
                    this.collect.list = res.list;
                });
        },

        share(item) {
            this.$ajax
                .get('/product/createShareCode', {
                    params: { id: item.id },
                })
                .then(res => {
                    this.imgUrl = Vue.filter('imgFormat')(res.data);
                    this.shareShow = true;
                });
        },
        //确定修改信息
        confirm() {
            if (!this.info.name) {
                this.$message({
                    message: '请输入作品名称',
                    type: 'warning',
                });
                return;
            }
            console.log(this.info);
            this.$ajax
                .get('/product/updateNameById', {
                    params: {
                        id: this.info.id,
                        name: this.info.name,
                    },
                })
                .then(response => {
                    this.$message({
                        message: '设置成功',
                        type: 'success',
                    });
                    this.infoShow = false;
                    this.getWorkList();
                });
        },
        //获取信息
        getInfo(item) {
            this.info = JSON.parse(JSON.stringify(item));
            this.infoShow = true;
        },
        viewMaterials(item) {
            console.log(item);
            this.materials = JSON.parse(JSON.stringify(item.useMaterials));
            this.materialsShow = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.share_pop {
    width: 360px;
    height: 360px;
}

.opt_part {
    height: 35px;
    background: #000000b7;
    color: #fff;
    font-size: 12px;
    position: absolute;
    z-index: 999;
    width: 100%;
    bottom: 65px;
    opacity: 0;
    transition: all 0.3s;

    > div {
        flex: 1;
        height: 100%;

        + div {
            position: relative;

            &:before {
                position: absolute;
                content: '';
                width: 1px;
                height: 15px;
                background: #fff;
                top: 10px;
                left: 0px;
            }
        }
    }

    i {
        margin-right: 5px;
    }
}
.opt_part2 {
    height: 35px;
    background: #000000b7;
    color: #fff;
    font-size: 12px;
    border-radius: 0 0 10px 10px;
    position: absolute;
    z-index: 999;
    width: 100%;
    bottom: 30px;
    opacity: 0;
    transition: all 0.3s;

    > div {
        flex: 1;
        height: 23px;
        margin: 0 4px;
        background: #F6FAF6;
        border-radius: 4px;
        font-size: 12px;
        color: #333333;
        + div {
            position: relative;

        }
    }
}
.opt_part2_1 {
    background: #ADD9BB !important;
}

.work {
    padding: 0;
}
.page-intro { display: flex; align-items: flex-start; justify-content: space-between; gap: 24px; margin-bottom: 24px; }
.page-intro h1 { margin: 0; color: #18201c; font-size: 28px; font-weight: 700; }
.page-intro p { margin: 8px 0 0; color: #89948d; font-size: 14px; }
.new-work-editor-link { display: block; margin: 0 -20px; padding: 0 20px; color: inherit; text-decoration: none; }
.work-toolbar { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; padding: 16px; border: 1px solid #e8eee9; border-radius: 18px; background: #fff; }
.toolbar-right { display: flex; gap: 10px; }
.toolbar-right .el-input { width: 240px; }
.work-summary { margin: 22px 2px 0; color: #89948d; font-size: 13px; }
.work-meta { padding: 0 16px 16px; text-align: left !important; }
.work-name { padding: 0; color: #18201c; font-size: 16px; font-weight: 650; text-align: left !important; }
.work-time { margin-top: 5px; color: #89948d; font-size: 12px; text-align: left; }
.work-type-tag {
    position: absolute;
    top: 14px;
    left: 14px;
    z-index: 2;
    max-width: calc(100% - 68px);
    overflow: hidden;
    padding: 6px 10px;
    border: 1px solid rgba(255,255,255,.82);
    border-radius: 999px;
    color: #3f4d45;
    background: rgba(255,255,255,.9);
    box-shadow: 0 5px 14px rgba(31,66,47,.08);
    font-size: 12px;
    font-weight: 650;
    text-overflow: ellipsis;
    white-space: nowrap;
    backdrop-filter: blur(10px);
}
.creative-more { position: absolute; top: 12px; right: 12px; z-index: 3; }
.creative-more-button {
    width: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e3ebe5;
    border-radius: 12px;
    color: #526158;
    background: rgba(255,255,255,.94);
    box-shadow: 0 7px 18px rgba(31,66,47,.1);
    cursor: pointer;
    opacity: 0;
    transform: translateY(-4px);
    transition: .2s ease;
}
.creative-more-button:hover { color: #fff; border-color: #21965b; background: #21965b; }
.creative-open-tip {
    position: absolute;
    right: 14px;
    bottom: 14px;
    z-index: 2;
    padding: 7px 11px;
    border-radius: 999px;
    color: #fff;
    background: rgba(24,32,28,.74);
    font-size: 12px;
    opacity: 0;
    transform: translateY(5px);
    transition: .2s ease;
    backdrop-filter: blur(8px);
}
.work-card--creative:hover .creative-more-button,
.work-card--creative:focus-within .creative-more-button,
.work-card--creative:hover .creative-open-tip { opacity: 1; transform: translateY(0); }
.work-card--creative .work-cover { transition: border-color .2s ease, transform .2s ease; }
.work-card--creative:hover .work-cover { border-color: #b9dfc8; transform: translateY(-2px); }
@media (max-width: 700px) {
    .page-intro { flex-direction: column; }
    .toolbar-right, .toolbar-right .el-input { width: 100%; }
}

.no_data {
    text-align: center;
    color: #999;
    margin-top: 50px;

    i {
        font-size: 150px;
    }

    div {
        margin-top: 10px;
    }
}

.data_list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(235px, 1fr));
    gap: 20px;
    width: 100%;
    padding-top: 18px;

    > div {
        margin: 0;
        position: relative;
        overflow: hidden;
        border: 1px solid #e8eee9;
        border-radius: 20px;
        background: #fff;
        box-shadow: 0 8px 24px rgba(33,79,53,.05);

        > div {
            &:first-child {
                height: 240px;
                width: 100%;
                background: #fff;
                border-radius: 0;
                cursor: pointer;
                background-position: center center;
                background-size: contain;
                background-repeat: no-repeat;
            }

            text-align: center;

            &:last-child { margin-top: 15px; }
        }

        &:hover .opt_part {
            opacity: 1;
        }
        &:hover .opt_part2 {
            opacity: 1;
        }
    }
}

.creative-action-menu {
    min-width: 170px;
    padding: 6px;
    border: 1px solid #e4ebe6;
    border-radius: 12px;
    box-shadow: 0 12px 28px rgba(31,66,47,.12);
}
.creative-action-menu .el-dropdown-menu__item { border-radius: 8px; color: #48544d; font-size: 13px; }
.creative-action-menu .el-dropdown-menu__item:not(.is-disabled):hover { color: #21965b; background: #edf8f1; }

.collect_list {
    .scene_tag {
        margin-top: 8px;
    }

    > div {
        > div {
            &:first-child {
                background-size: 150px 150px;
            }
        }
    }
}

.cf21 {
    color: #6e9f21;
}
</style>
